import { render, staticRenderFns } from "./company-info.vue?vue&type=template&id=54220214&scoped=true&"
import script from "./company-info.vue?vue&type=script&lang=js&"
export * from "./company-info.vue?vue&type=script&lang=js&"
import style0 from "./company-info.vue?vue&type=style&index=0&id=54220214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54220214",
  null
  
)

export default component.exports